<div class="table-responsive">
  <table class="table table-bordered" [ngClass]="{ 'table-hover': hoverStyle }">
    @if (config.rows.length > 0) {
      <ng-content select="[header]"></ng-content>
    }
    <ng-content select="[body]"></ng-content>
  </table>
  @if (config.rows.length == 0) {
    <div class="w-100 text-center mt-4">
      <h4>{{ noElementsLabel | translate }}</h4>
    </div>
  }
  @if (withPagination) {
    <div class="w-100 text-center mt-1">
      <s1-pagination #pagination [table]="config" [onlinePagination]="onlinePagination" (pageChanged)="paginationUpdated()" ></s1-pagination>
    </div>
  }
</div>